export default __webpack_public_path__ + "static/media/verified_icon.7c2b3369.svg";